<template>
  <div>
    <v-card>
      <v-card-text>
        <table>
            <tr v-if="poType == 'sale' || isOperator">
              <td>{{ $t('client') }}</td>
              <td> : </td>
              <td> <h3>{{ poDoc.client_name }}</h3> </td>
            </tr>
            
            <tr v-if="poType == 'order' || isOperator">
              <td>{{ $t('supplier') }}</td>
              <td> : </td>
              <td> <h3>{{ poDoc.supplier_name }}</h3> </td>
            </tr>


            <tr>
              <td>{{ $t('phone') }}</td>
              <td> : </td>
              <td> {{ (poType == 'order' ? poDoc.supplier_mobile : poDoc.client_phone) | formatPhoneNumber }}</td>
            </tr>

            <tr>
              <td>{{ $t('reference') }}</td>
              <td> : </td>
              <td> {{ poDoc.reference }}</td>
            </tr>

            <tr>
              <td>{{ $t('totalAmount') }}</td>
              <td> : </td>
              <td> <h3>{{ parseFloat(poDoc.total_amount) | formatNumber }}{{ getCurrencySymbol(poDoc.currency_code) }} </h3></td>
            </tr>

            <tr>
              <td>{{ $t('note') }}</td>
              <td> : </td>
              <td>{{ poDoc.note }} </td>
            </tr>
            
        </table><br>

        <v-data-table
          :headers="orderLineHeader"
          :items="poDoc.transaction_order_line"
          hide-default-footer
          mobile-breakpoint="0"
        >
          <template v-slot:header.number="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.name="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.order_qty="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.price="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.product_description="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.total_amount="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.action="{ header }">{{ $t(header.text) }}</template>

          <template v-slot:item.number={index}>{{ index + 1 }}</template>
          <template v-slot:item.order_qty="{ item }">{{ parseFloat(item.order_qty) | formatNumber }}</template>
          <template v-slot:item.product_description="{ item }">{{item.product_description && item.product_description.substr(0, 9) || ""}} {{ item.product_description && item.product_description.length > 9 ? "..." : "" }}</template>
          <template v-slot:item.price="{ item }">{{ item.price | formatNumber }}{{ item.currency_symbol }}</template>
          <template v-slot:item.total_amount="{ item }">{{ item.sub_total | formatNumber }}{{ item.currency_symbol }}</template>
        </v-data-table>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-3">
        <v-btn
          elevation="2"
          rounded
          small
          depressed
          @click="handleClose(false)"
        >
          <font-awesome-icon icon="times-circle" class="mr-2"/>
          {{ $t('close') }}
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn
          elevation="2"
          rounded
          small
          depressed
          color="error"
          v-if="showBtn"
          @click="handleRejected(poDoc)"
        > 
          <font-awesome-icon icon="exclamation-circle" class="mr-2"/>
          {{ $t('reject') }}
        </v-btn>

        <v-btn
          elevation="2"
          rounded
          small
          depressed
          v-if="showBtn"
          color="success"
          @click="handleAccepted(poDoc)"
        >
          <font-awesome-icon icon="check-circle" class="mr-2"/>
          {{ $t('accept') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import {provider} from "@/service/provider";
import moment from "moment";
import axios from "axios";
import MainMixin from "../../../mixins/mainMixin";



export default {
  name: "poDetail",
  props: ["poType", "poDoc", "showBtn"],
  mixins: [MainMixin],

  data() {
    return {
      orderLineHeader: [
        {text: "number", align: "start", sortable: false, value: "number"},
        {text: "productName", align: "start", sortable: false, value: "name"},
        {text: "qty", value: "order_qty", sortable: false},
        {text: "price", value: "price", sortable: false},
        {text: "amount", value: "total_amount", sortable: false},
      ],
    };
  },
  created() {
  },
  methods: {
    handleClose(val) {
      this.$emit('handleApprovedOrRejected', val);
    },
    handleAccepted(doc) {
      let vm = this;
      let url = provider.baseURL + "/update_transaction_order_status";
      let req = {};
      req.id = doc.id;
      req.status = "accepted";
      req.accepted_by_id = localStorage.id;
      req.accepted_date = moment().format("DD-MM-YYYY");
      return new Promise((resolve, reject) => {
        axios.post(url, req, {headers: {Authorization: localStorage.token}}).then(
            res => {
              if (res.data.response && res.data.response.code === 200) {
                resolve(res.data);
                vm.$notify({
                  title: vm.$t('acceptedSuccess'),
                  message: vm.$t("success"),
                  type: "success",
                  duration: 1000
                });
                vm.handleClose();
              }
            },
            error => {
              reject(error);
            }
        );
      })
    },
    handleRejected(doc) {
      let vm = this;
      let url = provider.baseURL + "/update_transaction_order_status";
      let req = {};
      req.id = doc.id;
      req.status = "declined";
      req.accepted_by_id = localStorage.id;
      req.accepted_date = moment().format("DD-MM-YYYY");
      return new Promise((resolve, reject) => {
        axios.post(url, req, {headers: {Authorization: localStorage.token}}).then(
            res => {
              if (res.data.response && res.data.response.code === 200) {
                resolve(res.data);
                vm.$notify({
                  title: vm.$t('rejectSuccess'),
                  message: vm.$t("success"),
                  type: "warning",
                  duration: 1000
                });
                vm.handleClose();
              }
            },
            error => {
              reject(error);
            }
        );
      })
    }
  }
};
</script>
